import { useEffect, useState } from "react"
import { Action, PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { CreditAccountsPanel } from "./creditAccountsPanel"
import { Customer, SaleOperation, SaleOrder, useCustomerLoaders, useHoardLoaders, useSaleLoaders } from "../../../../sales"
import { CreditPayment } from "../../../state/types"
import { useCreditPaymentLoaders } from "../../../loaders/creditPaymentLoaders"
import { useNavigate } from "react-router-dom"
import { RoutePath } from "../../../../../features/routes"

export const CreditAccountsPanelLoader = () => {
    const [sales, setSales] = useState<SaleOrder[]>([])
    const [operations, setOperations] = useState<SaleOperation[]>([])
    const [customers, setCustomers] = useState<Customer[]>([])
    const [creditPayments, setCreditPayments] = useState<CreditPayment[]>([])
    const [ready, setReady] = useState(false)
    
    const navigate = useNavigate()

    const saleLoaders = useSaleLoaders()
    const hoardLoaders = useHoardLoaders()
    const customerLoaders = useCustomerLoaders()
    const creditPaymentLoaders = useCreditPaymentLoaders()

    const load = async () => {
        const { loadCreditAccountSales } = saleLoaders()
        const loadedSales = await loadCreditAccountSales()
        setSales(loadedSales)
        const { loadCreditAccountHoards } = hoardLoaders()
        const loadedHoards = await loadCreditAccountHoards(true)
        const loadedOperations = [...loadedSales, ...loadedHoards].filter(operation => !operation.cancelled)
        setOperations(loadedOperations)
        const { loadCustomers } = customerLoaders()
        const loadedCustomers = await loadCustomers(loadedOperations.map(operation => operation.customerId))
        setCustomers(loadedCustomers)
        const { loadCustomersCreditPayments } = creditPaymentLoaders()
        const loadedCreditPayments = await loadCustomersCreditPayments(loadedCustomers.map(customer => customer.id), true)
        setCreditPayments(loadedCreditPayments.filter(creditPayment => !creditPayment.archived))
    }

    useEffect(() => {
        setReady(false)
        load().then(() => setReady(true))
    }, [])

    const onGoToCreditDebtsList = () => navigate(RoutePath.DEBTS)

    const headerActions: Action[] = [
        {
            label: 'Lista de Deudores',
            kind: 'tertiary',
            onClick: onGoToCreditDebtsList
        }
    ]

    return (
        <PanelLoader
            title="Cuentas Corrientes"
            actions={headerActions}
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.CREDIT_ACCOUNTS} />}
        >
            <CreditAccountsPanel
                sales={sales}
                operations={operations}
                customers={customers}
                creditPayments={creditPayments}
            />
        </PanelLoader>
    )
}
